export default __webpack_public_path__ + "static/media/ca.4ea31f75.png";